import ArgonBox from "component/Argon/ArgonBox";

const sidenav_end = [
  {
    type: 'collapse',
    name: 'ออกจากระบบ',
    key: 'signout',
    route: '/sign-out',
    noCollapse: true,
    icon: (
      <ArgonBox
        component="i"
        color="error"
        fontSize="14px"
        className="ni ni-lock-circle-open"
      />
    )
  }
];


export default sidenav_end;
